<template>
  <div>
    <div class="app-header">
      <div>
        <router-link to="/">&larr; BACK</router-link>
      </div>
      <div>
        <a href="#" v-on:click.prevent='hidePreview = !hidePreview'><span style="line-height: 0; font-size: 200%; position: relative; top: 0.22em;">◧</span> {{ hidePreview ? 'show' : 'hide' }} preview</a>
        &nbsp;
        &nbsp;
        &nbsp;
        <router-link :to="{ name: 'preview', params: { id: $route.params.id }}" target="_blank">
          <a>↗ open preview</a>
        </router-link>
        &nbsp;
        &nbsp;
        &nbsp;
        <a href="#" v-on:click.prevent="exporting = true" class="publish">✔ publish</a>
      </div>
    </div>
    <div v-if="exporting" class="exporter">
      <div class="exporter-background">
        <span class="close-button" v-on:click="exporting = false">&times;</span>
        <ExportPage />
      </div>
      <div class="background-blackout" v-on:click="exporting = false" />
    </div>
    <div class="parent">
      <div class="edit-frame">
        <form class="edit-form" @submit.prevent="savePage">
          <p><strong>FONTS</strong></p>
          <div class="field">
            <div class="file" v-for="file in page.typefaces">
              {{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}
            </div>
            <div class="control">
              <file-uploader @url="onTypefaceUpload" class="uploader--wide" />
              <input classNames="input" type="hidden" placeholder="" v-model="page.typefaces" />
            </div>
          </div>

          <div class="section">
            <br>
            <p><strong>PAGE INTRO</strong></p>
            <Edit-IntroBlock v-if="page.introData" key="intro" :data="page.introData" v-on:updateBlock="updateIntro">
              <div v-if="page.styles" class="row">
                <div class="field">
                  <label class="label">Font</label>
                  <div class="select">
                    <select v-model="page.styles.intro_font">
                      <option value="">Default</option>
                      <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                    </select>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Font colour</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="#000000" v-model="page.styles.intro_font_colour" />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Font size</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="24px" v-model="page.styles.intro_font_size" />
                  </div>
                </div>
              </div>
            </Edit-IntroBlock>
          </div>
          <hr><br>

          <p><strong>META</strong></p>
          <br>
          <div class="row">
            <div class="field">
              <label class="label">Name</label>
              <div class="control">
                <input class="input" type="text" placeholder="Name" v-model="page.name" required>
              </div>
            </div>
            <div class="field">
              <label class="label">Page title</label>
              <div class="control">
                <input class="input" type="text" placeholder="Name" v-model="page.title" required>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="field">
              <label class="label">Description</label>
              <div class="control">
                <textarea rows="4" v-model="page.description"></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">URL</label>
              <div class="control">
                <input class="input" type="text" placeholder="URL" v-model="page.url" />
              </div>
            </div>
          </div>
          <div class="field field--small">
            <a href="#" v-on:click="page.socialImage = null" class="delete nested">x</a>
            <label class="label">Social image</label>
            <div class="control">
              <img :src="page.socialImage" />
              <div v-if="!page.socialImage">
                <file-uploader @url="onSocialUpload" />
                <input class="input" type="hidden" placeholder="" v-model="page.socialImage" />
              </div>
            </div>
          </div>

          <hr><br>

          <p><strong>GENERAL STYLES</strong></p>
          <br>
          <label class="underline">PAGE</label>
          <div v-if="page.styles" class="row">
            <div class="field">
              <label class="label">Background colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#cccccc" v-model="page.styles.backgroundColour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Highlight colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#FFD700" v-model="page.styles.highlightColour" />
              </div>
            </div>
          </div>
          <hr><br>

          <p><strong>TEXT STYLES</strong></p>
          <br>
          <div v-if="page.styles" class="row">
            <label class="underline">Default</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.default_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.default_font_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.default_font_size" />
              </div>
            </div>
          </div>
          <div v-if="page.styles" class="row">
            <label class="underline">HEADER 1</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.h1_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.h1_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.h1_size" />
              </div>
            </div>
          </div>

          <br>
          <div v-if="page.styles" class="row">
            <label class="underline">HEADER 2</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.h2_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.h2_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.h2_size" />
              </div>
            </div>
          </div>
          <br>
          <div v-if="page.styles" class="row">
            <label class="underline">HEADER 3</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.h3_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.h3_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.h3_size" />
              </div>
            </div>
          </div>
          <br>
          <div v-if="page.styles" class="row">
            <label class="underline">CAPTION</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.caption_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.caption_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.caption_size" />
              </div>
            </div>
          </div>
          <br>
          <div v-if="page.styles" class="row">
            <label class="underline">BLOCKQUOTE</label>
            <div class="field">
              <label class="label">Font</label>
              <div class="select">
                <select v-model="page.styles.blockquote_font">
                  <option value="">Default</option>
                  <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Font colour</label>
              <div class="control">
                <input class="input" type="text" placeholder="#000000" v-model="page.styles.blockquote_colour" />
              </div>
            </div>
            <div class="field">
              <label class="label">Font size</label>
              <div class="control">
                <input class="input" type="text" placeholder="24px" v-model="page.styles.blockquote_size" />
              </div>
            </div>
          </div>

          <div class="section">
            <p><strong>PAGE BLOCKS</strong></p>
            <br>
            <br>
            <div>
              <div :is="block.editComponentName" v-for="block in sortedBlocks" :key="block.id" :data="block" v-on:updateBlock="updateBlock" v-on:moveUp="moveUp" v-on:moveDown="moveDown" v-on:deleteBlock="deleteBlock"></div>
            </div>
            <button v-for="component in componentTypes.blocks" v-on:click="addBlock(component)">New {{ component.name }} block</button>
          </div>
          <hr><br>
          <div class="section">
            <br>
            <p><strong>PAGE FOOTER</strong></p>
            <Edit-FooterBlock v-if="page.footerData" key="footer" :data="page.footerData" v-on:updateBlock="updateFooter">
              <div v-if="page.styles" class="row">
                <div class="field">
                  <label class="label">Font</label>
                  <div class="select">
                    <select v-model="page.styles.footer_font">
                      <option value="">Default</option>
                      <option v-for="file in page.typefaces" :value="file.url">{{ file.url.split('uploads%2F')[1].split('?')[0].replace(/^\d+-/, '') }}</option>
                    </select>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Font colour</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="#000000" v-model="page.styles.footer_font_colour" />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Font size</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="24px" v-model="page.styles.footer_font_size" />
                  </div>
                </div>
              </div>
            </Edit-FooterBlock>
          </div>

        </form>
      </div>
      <iframe v-show="!hidePreview" class="preview-frame" :src="'/#/preview/'+this.$route.params.id"></iframe>
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'
import _ from 'lodash'
import crypto from 'crypto'
import componentTypes from '@/config/blocks.json'
import { VueEditor } from 'vue2-editor'
import FileUploader from '@/components/FileUploader'
import EditIntroBlock from '@/components/Edit-IntroBlock'
import EditTextBlock from '@/components/Edit-TextBlock'
import EditHtmlBlock from '@/components/Edit-HtmlBlock'
import EditImageBlock from '@/components/Edit-ImageBlock'
import EditVideoBlock from '@/components/Edit-VideoBlock'
import EditTwoColBlock from '@/components/Edit-TwoColBlock'
import EditFooterBlock from '@/components/Edit-FooterBlock'
import ExportPage from '@/components/Export-Page'

export default {
  name: 'edit-page',
  data () {
    return {
      componentTypes: componentTypes,
      hidePreview: false,
      exporting: false,
      page: {
        name: '',
        title: '',
        description: '',
        url: '',
        socialImage: '',
        introData: { introText: '', images: {}, videos: {}, introLogo: {} },
        introFooter: { footerText: '', images: {}, footerLogo: {}, footerBackgroundColour: '' },
        styles: {},
        typefaces: [],
        blocks: [],
      }
    }
  },
  components: {
    EditIntroBlock,
    EditFooterBlock,
    EditTextBlock,
    EditHtmlBlock,
    EditImageBlock,
    EditVideoBlock,
    EditTwoColBlock,
    ExportPage,
    FileUploader,
    VueEditor
  },
  firestore() {
    return {
      page: firestore.collection('pages').doc(this.$route.params.id)
    }
  },
  created: function () {
    setInterval(this.updateDB, 1000)
  },
  updated: function() {
    if (!this.page || !this.page.name) return
    this.savePage()
  },
  computed: {
    sortedBlocks: function() {
      function compare(a, b) {
        return (a.order || 0) - (b.order || 0)
      }
      return this.page.blocks ? this.page.blocks.sort(compare) : []
    }
  },
  methods: {
    startExport() {
    },
    onSocialUpload(url) {
      this.page.socialImage = url
    },
    onTypefaceUpload(url, id) {
      if (!this.page.typefaces) this.page.typefaces = []
      let index = _.findIndex(this.page.typefaces, { 'id': id })
      if (index < 0) {
        this.page.typefaces.push({ id: crypto.randomBytes(16).toString("hex"), url: url })
      } else {
        this.$set(this.page.typefaces, index, url)
      }
      this.update()
    },
    addBlock(component) {
      if (!this.page.blocks) this.page.blocks = []
      var o = { id: crypto.randomBytes(16).toString("hex"), order: 9999, componentName: component.componentName, editComponentName: component.editComponentName }
      this.page.blocks.push(o)
    },
    updateIntro (data) {
      if (!data) return
      //if (_.isEqual(data, this.page.introData)) return
      this.$set(this.page, 'introData', data)
      this.savePage()
    },
    updateFooter (data) {
      if (!data) return
      //if (_.isEqual(data, this.page.introData)) return
      this.$set(this.page, 'footerData', data)
      this.savePage()
    },
    updateBlock (data) {
      if (!data) return
      let index = _.findIndex(this.page.blocks, { 'id': data.id })
      this.$set(this.page.blocks, index, data)
      this.savePage()
    },
    deleteBlock (data) {
      if (confirm('Are you sure you want to delete this?')) {
        let index = _.findIndex(this.page.blocks, { 'id': data.id })
        this.$delete(this.page.blocks, index)
      }
    },
    arrayMove (index, array, delta) {
      var newIndex = index + delta;
      if (newIndex < 0  || newIndex == array.length) return;
      var indexes = [index, newIndex].sort((a, b) => a - b);
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    },
    moveUp (data) {
      let index = _.findIndex(this.page.blocks, { 'id': data.id })
      let blocks = _.map(this.page.blocks, 'id')
      this.arrayMove(index, blocks, 1)
      for (let i=0;i<blocks.length;i++) {
        let index = _.findIndex(this.page.blocks, { 'id': blocks[i] })
        this.$set(this.page.blocks[index], 'order', i)
      }
      this.savePage()
    },
    moveDown (data) {
      let index = _.findIndex(this.page.blocks, { 'id': data.id })
      let blocks = _.map(this.page.blocks, 'id')
      this.arrayMove(index, blocks, -1)
      for (let i=0;i<blocks.length;i++) {
        let index = _.findIndex(this.page.blocks, { 'id': blocks[i] })
        this.$set(this.page.blocks[index], 'order', i)
      }
      this.savePage()
    },
    savePage () {
      this.page.changed = true
    },
    updateDB () {
      if (this.page.changed) {
        //console.log('UPDATED DB')
        this.page.changed = false
        this.$firestore.page.update({
          title: this.page.title,
          name: this.page.name,
          description: this.page.description || '',
          url: this.page.url || '',
          socialImage: this.page.socialImage || '',
          introData: this.page.introData || { introText: '', images: { classNames: [] }, videos: { classNames: [] }, introLogo: {} },
          footerData: this.page.footerData || { footerText: '', images: { classNames: [] }, footerLogo: {}, footerBackgroundColour: '' },
          styles: this.page.styles || {},
          typefaces: this.page.typefaces || [],
          blocks: this.page.blocks || [],
        })
      } else {
        //console.log('no update')
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.parent {
  display: flex;
  font-family: sans-serif;
  height: calc(100vh - 4rem);
  overflow: hidden;
}
.edit-frame {
  background-color: #eee;
  flex: 1;
  overflow: auto;
}
.preview-frame {
  border: 0;
  flex: 1;
}

.edit-form {
  max-width: 55rem;
}

.block {
  border-left: 0.25rem solid #ccc;
  padding-left: 2rem;
  margin-bottom: 5rem;
  position: relative;
}
.block .field {
  padding-top: 0 !important;
}

.file {
  background: #ccc;
  padding: 1rem;
  margin-bottom: 0.5em;
}
.file:before {
  content: "␥";
  color: #666;
  font-size: 120%;
  position: relative;
  top: 0.1em;
}

.publish:hover {
  background: white;
  color: limegreen;
}
.publish,
.publish:active {
  background: limegreen;
  color: white;
  display: inline-block;
  padding: 0.6em 1.2em;
}
.background-blackout {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
.exporter {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
.close-button {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 1rem;
  font-size: 150%;
}
.exporter-background {
  position: absolute;
  background: white;
  width: 20rem;
  height: 12rem;
  font-family: "courier new", monospace;
  padding: 8rem;
  text-align: center;
  color: black;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/Edit-Page.vue